import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ArrowUpIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        id="Vector"
        d="M7.40102 5.75027C7.4777 5.66707 7.56558 5.60445 7.66468 5.5624C7.76318 5.5208 7.87495 5.5 8 5.5C8.12505 5.5 8.23682 5.5208 8.33532 5.5624C8.43383 5.604 8.52171 5.66662 8.59898 5.75027L11.9018 9.67069C11.9342 9.71587 11.9587 9.76351 11.9752 9.81361C11.9917 9.86371 12 9.91134 12 9.95652C12 10.1023 11.9351 10.2294 11.8054 10.3376C11.6756 10.4459 11.5022 10.5 11.2851 10.5L4.71489 10.5C4.49782 10.5 4.32441 10.4457 4.19465 10.337C4.06488 10.2278 4 10.1006 4 9.95518C4 9.91 4.00826 9.86259 4.02477 9.81294C4.0407 9.76328 4.06518 9.71587 4.09821 9.67069L7.40102 5.75027Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

ArrowUpIcon.displayName = 'ArrowUpIcon';
